import { createFileRoute } from "@tanstack/react-router";
import { EpisodeRequestPage } from "@/features/game-resources";
import { loadEpisodeRequest } from "@/features/game-resources/records";
import {
  resourceHead,
  resourceSearchSchema,
} from "@/features/game-resources/navigation";

export const Route = createFileRoute(
  "/_site/unlisted/$coworld_/episode-requests/$requestId/watch",
)({
  validateSearch: (search) => resourceSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ params, deps, abortController }) =>
    loadEpisodeRequest({
      data: {
        resourceId: params.requestId,
        game: { slug: params.coworld, catalog_status: "unlisted" },
        search: deps.search,
      },
      signal: abortController.signal,
    }),
  head: () => resourceHead("Episode"),
  component: Page,
});

function Page() {
  return <EpisodeRequestPage data={Route.useLoaderData()} />;
}
